import React, { forwardRef } from 'react'

import { IconProps } from './types'

const ArrowRight = forwardRef<SVGSVGElement, IconProps>(
  ({ color, size, ...props }, ref) => (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M8 4L12 8M12 8L8 12M12 8L3 8" stroke={color} />
    </svg>
  ),
)

ArrowRight.displayName = 'ArrowRight'

ArrowRight.defaultProps = {
  size: 16,
  color: 'currentColor',
}

export default ArrowRight
